export const SYMBOLS = [
  { id: "lantern", label: "Lantern", emoji: "✦", color: "#f8d77a" },
  { id: "mirror", label: "Mirror", emoji: "◈", color: "#9ee7ff" },
  { id: "door", label: "Door", emoji: "▣", color: "#d6a3ff" },
  { id: "thread", label: "Thread", emoji: "⌁", color: "#9dffca" }
] as const;

export type SymbolId = typeof SYMBOLS[number]["id"];
export type Role = "A" | "B";

export type Config = {
  turnstileSiteKey: string;
  consentVersion: string;
  consentLine: string;
  serverTime: string;
};

export type Session = {
  token: string;
  expiresAt: number;
  deviceHashPreview: string;
  consentVersion: string;
};

export type RoundResult = {
  frontier: number;
  accuracy: boolean[];
  score: number;
  targetDepth: number;
};

export type ServerMessage =
  | { type: "hello"; clientId: string; consentVersion: string; serverTime: string }
  | { type: "queued"; queueSize: number; maxDepth: number }
  | { type: "matched"; roomId: string; role: Role; round: number; maxDepth: number; symbols: typeof SYMBOLS; opponentTag: string }
  | { type: "partner_submitted"; roomId: string; round: number }
  | {
      type: "round_result";
      roomId: string;
      round: number;
      role: Role;
      your: RoundResult;
      partner: RoundResult;
      yourChain: SymbolId[];
      partnerChain: SymbolId[];
      partnerConfidence: number[];
      nextLesson: string;
    }
  | { type: "training"; roomId: string; round: number; targetDepth: number; prompt: string }
  | { type: "ended"; reason: string }
  | { type: "stats"; stats: CommonsStats }
  | { type: "pong"; at: number; serverTime: string }
  | { type: "error"; message: string; code?: string };

export type CommonsStats = {
  totalRounds: number;
  uniqueDevicesApprox: number;
  averageFrontier: number;
  frontierHistogram: Record<string, number>;
  medianReactionMs: number;
  symbolBias: Record<SymbolId, number>;
  updatedAt: string;
};

export const DEPTH_PROMPTS = [
  "Reveal your symbol.",
  "What will the stranger reveal?",
  "What do they think you will reveal?",
  "What do they think you think they will reveal?",
  "What do they think you think they think you will reveal?",
  "What do they think you think they think you think they will reveal?",
  "What do they think you think they think you think they think you will reveal?"
];
